<template>
  <section class="team-snapshot position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-9 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-10 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-11 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-12 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="team-header text-center">
            <div class="team-section-label">
              <h4>{{ content.header.sectionLabel }}</h4>
            </div>
            <div class="team-main-title">
              <h2>{{ content.header.mainTitle }}</h2>
            </div>
            <div class="team-description">
              <p>{{ content.header.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-3 col-md-6 mb-4" v-for="(member, index) in content.teamMembers" :key="index">
          <div class="team-member">
            <div class="member-bg">
              <div class="block-shape-1"></div>
              <div class="block-shape-2"></div>
            </div>
            <div class="member-content">
              <div class="member-avatar">
                <div class="avatar-placeholder">
                  <i :class="member.icon"></i>
                </div>
              </div>
              <h3>{{ member.name }}</h3>
              <div class="member-role">{{ member.role }}</div>
              <p>{{ member.description }}</p>
              <div class="member-expertise">
                <span class="expertise-tag" v-for="(expertise, expIndex) in member.expertise" :key="expIndex">
                  {{ expertise }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutTeamComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-9 {
  top: 18%;
  left: 12%;
  width: 105px;
  height: 105px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-10 {
  bottom: 30%;
  right: 12%;
  width: 75px;
  height: 75px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-11 {
  top: 45%;
  left: 8%;
  width: 125px;
  height: 125px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-12 {
  bottom: 18%;
  right: 18%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

/* Team Section */
.team-snapshot {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.team-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.team-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.team-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.team-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.team-member {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 30px;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.team-member:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(246, 236, 79, 0.2);
  border-color: #F6EC4F;
}

.member-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.member-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.member-avatar {
  margin-bottom: 20px;
}

.avatar-placeholder {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.avatar-placeholder i {
  font-size: 32px;
  color: #00061A;
}

.member-content h3 {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.member-role {
  color: #F6EC4F;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.member-content p {
  font-size: 14px;
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.6;
}

.member-expertise {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.expertise-tag {
  background: rgba(246, 236, 79, 0.1);
  color: #F6EC4F;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid rgba(246, 236, 79, 0.2);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .team-snapshot {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .team-snapshot {
    padding: 60px 0;
  }
  
  .team-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .team-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .team-member {
    padding: 30px 20px;
  }
}

@media only screen and (max-width: 399px) {
  .team-snapshot {
    padding: 40px 0;
  }
  
  .team-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
